<template>
  <div class="split-icon float-left">
    <a
      class="home-split d-block"
      href="#"
      @click.prevent="openComposeEmail()"
    >
      <transition name="fade-full" mode="out-in">
        <img :src="composeEmailIcon" class="month-view-cal" />
      </transition>
    </a>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        composeEmailIcon: require("../../assets/img/icon-compose-email.png")
      };
    },
    methods: {
      openComposeEmail() {
        this.$router.push("/compose-email");
      }
    }
  };
</script>

<style scoped>
  img {
    max-width: 27px;
  }

  .fade-full-enter {
    opacity: 0;
  }

  /* stage 2. Entered */
  .fade-full-enter-active {
    transition: opacity 0.1s ease-in-out;
  }

  /* stage 3. leave */
  .fade-full-leave-active {
    opacity: 0;
    transition: opacity 0.1s ease-in-out;
  }
</style>
